<template>
	<div class="mx-1">
		<v-btn
			v-for="(item, index) in availability"
			:key="index"
			block
			class="ma-1"
			:outlined="true"
			color="blue-grey"
			:x-small="true"
			:disabled="!item"
		>
			{{ item ? 'available' : 'unavailable' }}
		</v-btn>
	</div>
</template>

<script>
export default {
	props: {
		availability: { type: Array, required: true },
		blockSize: { type: Number, required: true }
	}
};
</script>

<style></style>
